import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cardNumber'
})
export class CardNumberPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }

    // Remove non-digit characters
    const cleanValue = value.replace(/\D/g, '');

    // Split the number into groups of 4
    const groups = cleanValue.match(/.{1,4}/g);

    // Join the groups with spaces
    return groups ? groups.join(' ') : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/common/card-number.pipe.ts